import { render } from "./ticket_invoice.vue?vue&type=template&id=6acb0514"
import script from "./ticket_invoice.vue?vue&type=script&lang=js"
export * from "./ticket_invoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__